import {
  IReferral,
  IReferralMedia,
  ReferralCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  CollectionReference,
  IReffable,
  WithRef,
  multiUndeleted,
  Firestore,
  subCollection,
  initFirestoreModel,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';

export class ReferralMedia {
  static init(
    overrides: AtLeast<IReferralMedia, 'actor' | 'path'>
  ): IReferralMedia {
    return {
      name: '',
      tags: [],
      ...overrides,
      ...initFirestoreModel(),
    };
  }

  static col(
    referral: IReffable<IReferral>
  ): CollectionReference<IReferralMedia> {
    return subCollection<IReferralMedia>(
      referral.ref,
      ReferralCollection.Media
    );
  }

  static all$(
    referral: IReffable<IReferral>
  ): Observable<WithRef<IReferralMedia>[]> {
    return Firestore.query$(ReferralMedia.col(referral)).pipe(multiUndeleted());
  }
}
